// src/App.js
import React, { useState, useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline, Box, CircularProgress } from "@mui/material";
import Login from "./components/Login";
import DashboardLayout from "./components/layout/DashboardLayout";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Dashboard from "./dashboard";
import { EnvironmentProvider } from "./context/EnvironmentContext";
import AuthService from "./services/AuthService";

// Create your theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#3f51b5",
    },
    secondary: {
      main: "#f50057",
    },
    // The background color is likely defined here
    background: {
      default: "#d4d5d5", // This is probably what you want to change
      paper: "#ffffff",
    },
  },
  // other theme settings...
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#0054a4", // Custom header color
        },
      },
    },
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const checkAuth = async () => {
      if (AuthService.isAuthenticated()) {
        const isValid = await AuthService.validateToken();
        if (isValid) {
          setIsAuthenticated(true);
          setUser(AuthService.getUser());
        } else {
          // Token invalid, logout
          AuthService.logout();
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    AuthService.logout();
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <EnvironmentProvider>
          {isAuthenticated ? (
            <DashboardLayout
              onLogout={handleLogout}
              title={`Welcome, ${user?.displayName || user?.username}`}
            >
              <Dashboard onLogout={handleLogout} />
            </DashboardLayout>
          ) : (
            <Login onLogin={handleLogin} />
          )}
        </EnvironmentProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
